import Vue from 'vue'
import Search from './search.vue'
import GlobalSearch from './global-search.vue'
import AdminArticle from './admin-article.vue'
var _ = require('lodash')
require('es6-promise').polyfill();

if ($('#search').length > 0) {
    var htmlBrand = $('#dyn-machine-brand').text();
    var htmlDescription = $('#dyn-machine-brand-description').html();
    new Vue({
        el: '#search',
        render: h => h(Search, { props: { 'htmlBrand': htmlBrand, 'htmlBrandDescription': htmlDescription } })
    })
}

if ($('#global-search').length > 0) {
    new Vue({
        el: '#global-search',
        render: h => h(GlobalSearch)
    })
}

if ($('#admin-article').length > 0) {
    new Vue({
        el: '#admin-article',
        render: h => h(AdminArticle)
    })
}

var FileSaver = require('file-saver')
var axios = require('axios')
import { Spinner } from 'spin.js';
import 'spin.js/spin.css'
var spinner = new Spinner();

$(document).ready(function () {
    $('.special-download').each(function () {        
        $(this).on('click', function (e) {
            var link = $(this).attr('href');            
            var matches = link.match(/\/([^\?]*)\?.*/);
            var catName = (matches.length > 1) ? matches[1] : 'machines';
            e.preventDefault();
            try {
                var isFileSaverSupported = !!new Blob;
            } catch (e) {
                window.location.href = link;
                return;
            }

            var target = document.getElementById('special-download-animation');
            spinner.spin(target);
            $('.special-download').attr('disabled', true);

            var xhr = new XMLHttpRequest()
            xhr.open('GET', link)
            xhr.responseType = 'blob'
            xhr.onload = function () {
                spinner.stop();
                $('.special-download').attr('disabled', false);

                var contentDispo = xhr.getResponseHeader('Content-Disposition');
                // https://stackoverflow.com/a/23054920/
                var fileName = contentDispo.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];

                FileSaver.saveAs(xhr.response, fileName);
            }
            xhr.send();

            e.preventDefault();
        });
    });
});


// WEBPACK FOOTER //
// ./Content/Modern/js/vue/overlord.js